export default {
  error_msg: "",
  errors: [],
  success: false,
  consultants: [],
  consultant: [],
  next_consultants_url: "owner/doctor/list",
  requested_consultant_id: undefined,
  shouldAppend: true,
};
